<template>
  <div>
    <remCom v-if="clientWidth>600" />
    <baseCom v-else />
  </div>
</template>
  
<script>
import remCom from "./components/remCom.vue";
import baseCom from "./components/baseCom.vue";
import {mapState} from 'vuex'
export default {
  name: "ksgl-page",
  computed: {
		...mapState(['clientWidth']),
	},
  components: {
    remCom,
    baseCom
  },
  data() {
    return {
      
    };
  },
  created(){
    
  },
  methods: {
   
  }
};
</script>
